import { render } from "./message-system.vue?vue&type=template&id=10e42f56&scoped=true&ts=true"
import script from "./message-system.vue?vue&type=script&lang=ts"
export * from "./message-system.vue?vue&type=script&lang=ts"

import "./message-system.vue?vue&type=style&index=0&id=10e42f56&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e42f56"]])

export default __exports__